// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"b085f639","107":"f4df34e4","378":"71b9ea5c","665":"caa0776d","968":"bef8b0ae"}[chunkId] + ".js";
};